import { render, staticRenderFns } from "./Tab.vue?vue&type=template&id=011c607c&scoped=true"
import script from "./Tab.vue?vue&type=script&lang=js"
export * from "./Tab.vue?vue&type=script&lang=js"
import style0 from "./Tab.vue?vue&type=style&index=0&id=011c607c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "011c607c",
  null
  
)

export default component.exports